import { Case } from '../../../../common/models/common-types';

export const filterCases = function (cases: Case[], filterInput: string): Case[] {
    return cases.filter((node) => {
        const name = node.name.toLowerCase();
        const isIncludedInName = name.includes(filterInput.toLowerCase());
        if (node.children?.length > 0) {
            let list = [];
            const children = filterCases(node.children, filterInput);
            if (children.length > 0) {
                list.push(children);
                return list;
            }
        }
        if (isIncludedInName) {
            return node;
        }
        return null;
    });
};

export const filterCasesById = function (cases: Case[], activeCaseId: string): Case[] {
    return cases.filter((node) => {
        const isIncludedId = node.id === activeCaseId;
        if (node.children && node.children.length > 0) {
            let list = [];
            const children = filterCasesById(node.children, activeCaseId);
            list.push(children);
            const flatList = list.flat();
            if (flatList.length > 0) {
                node.children = flatList;
                return list;
            }
        }
        if (isIncludedId) {
            return node;
        }
        return null;
    });
};
